import { useCallback } from 'react';
import { UniqueIdentifier } from '@dnd-kit/core';
import { SchemaSection } from '@rossum/api-client/schemas';
import { Tile } from '@rossum/components/tile';
import { getDnDItems } from '../helpers';
import { FieldsList, FieldsListProps } from './FieldsList';

export type SectionsReorderingProps = {
  sections: SchemaSection[];
  onSectionsReorder: (
    from: readonly [UniqueIdentifier, number],
    to: readonly [UniqueIdentifier, number]
  ) => void;
};

export const SECTIONS_DROPPABLE_ID = 'sections-droppable';

export const SectionsReordering = ({
  sections,
  onSectionsReorder,
}: SectionsReorderingProps) => {
  const sectionsFieldsMap = sections.reduce<{
    [key: string]: SchemaSection;
  }>((acc, field) => {
    return {
      ...acc,
      [field.id]: field,
    };
  }, {});

  const items = getDnDItems([
    { id: SECTIONS_DROPPABLE_ID, children: sections },
  ]);

  const renderFieldItem: FieldsListProps['renderFieldItem'] = useCallback(
    fieldId => {
      const section = sectionsFieldsMap[fieldId];

      return section ? (
        <Tile title={section.label} data-cy="section-tile" />
      ) : null;
    },
    [sectionsFieldsMap]
  );

  return (
    <FieldsList
      items={items}
      renderFieldItem={renderFieldItem}
      onItemsReorder={onSectionsReorder}
    />
  );
};
